import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export type TDeleteEvvClientData = string;

const deleteEvvClient = (clientId: TDeleteEvvClientData) => {
  return http().delete(endpoints.evv.evvClientById.replace('{clientId}', clientId));
};

export function useDeleteEvvClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEvvClient,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchPaginatedEvvClients'] });
      }
    },
  });
}
